export const GET_GUEST_CHECKOUT = 'GIFTYA/GET_GUEST_CHECKOUT';
export const GET_GUEST_CHECKOUT_RESET = 'GIFTYA/GET_GUEST_CHECKOUT_RESET';
export const UPDATE_GUEST_CHECKOUT = 'GIFTYA/UPDATE_GUEST_CHECKOUT';
export const UPDATE_GUEST_CHECKOUT_RESET = 'GIFTYA/UPDATE_GUEST_CHECKOUT_RESET';
export const UPDATE_GUEST_CHECKOUT_CART_ITEM = 'GIFTYA/UPDATE_GUEST_CHECKOUT_CART_ITEM';
export const UPDATE_GUEST_CHECKOUT_CART_ITEM_RESET = 'GIFTYA/UPDATE_GUEST_CHECKOUT_CART_ITEM_RESET';
export const UPDATE_GUEST_CHECKOUT_CART_ITEM_DELIVERY_BY_PURCHASER = 'UPDATE_GUEST_CHECKOUT_CART_ITEM_DELIVERY_BY_PURCHASER';
export const SUBMIT_GUEST_CHECKOUT = 'GIFTYA/SUBMIT_GUEST_CHECKOUT';
export const SUBMIT_GUEST_CHECKOUT_RESET = 'GIFTYA/SUBMIT_GUEST_CHECKOUT_RESET';
export const GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE = 'GIFTYA/GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE';
export const GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE_RESET = 'GIFTYA/GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE_RESET';
export const GUEST_CHECKOUT_REMOVE_CART_ITEM = 'GIFTYA/GUEST_CHECKOUT_REMOVE_CART_ITEM';
export const GUEST_CHECKOUT_REMOVE_CART_ITEM_RESET = 'GIFTYA/GUEST_CHECKOUT_REMOVE_CART_ITEM_RESET';

export const getGuestCheckout = (payload, meta = {}, error = false) => ({
    type: GET_GUEST_CHECKOUT,
    payload,
    meta,
    error
});
export const getGuestCheckoutReset = (payload, meta, error) => ({
    type: GET_GUEST_CHECKOUT_RESET,
    payload,
    meta,
    error
});
export const updateGuestCheckout = (payload, meta = {}, error = false) => ({
    type: UPDATE_GUEST_CHECKOUT,
    payload,
    meta,
    error
});
export const updateGuestCheckoutReset = (payload, meta, error) => ({
    type: UPDATE_GUEST_CHECKOUT_RESET,
    payload,
    meta,
    error
});
export const updateGuestCheckoutCartItem = (payload, meta = {}, error = false) => ({
    type: UPDATE_GUEST_CHECKOUT_CART_ITEM,
    payload,
    meta,
    error
});
export const updateGuestCheckoutCartItemReset = (payload, meta, error) => ({
    type: UPDATE_GUEST_CHECKOUT_CART_ITEM_RESET,
    payload,
    meta,
    error
});
export const updateGuestCheckoutDeliveryByPurchaser = (payload, meta, error = false) => ({
    type: UPDATE_GUEST_CHECKOUT_CART_ITEM_DELIVERY_BY_PURCHASER,
    payload,
    meta,
    error
});
export const submitGuestCheckout = (payload, meta = {}, error = false) => ({
    type: SUBMIT_GUEST_CHECKOUT,
    payload,
    meta,
    error
});
export const submitGuestCheckoutReset = (payload, meta, error) => ({
    type: SUBMIT_GUEST_CHECKOUT_RESET,
    payload,
    meta,
    error
});

export const guestCheckoutRemoveCartItem = (payload, meta, error) => ({
    type: GUEST_CHECKOUT_REMOVE_CART_ITEM,
    payload,
    meta,
    error
});
export const guestCheckoutRemoveCartItemReset = (payload, meta, error) => ({
    type: GUEST_CHECKOUT_REMOVE_CART_ITEM_RESET,
    payload,
    meta,
    error
});